import { gql } from '../../__generated__/gql'

export const STORE_ITEM_QUERY = gql(`
  query storeItem($songId: Int!, $storeItemType: StoreItemTypeEnum!) {
    storeItem(songId: $songId, storeItemType: $storeItemType) {
      id
      software
      description
      price
      memberPrice
      itemType
      song {
        id
        key
      }
      samples {
        id
        name
        description
        attachmentUrl
        key
        originalKey
      }
      payloads {
        id
        attachmentUrl
        key
      }
      purchased
    }
  }
`)
